import React from 'react';
import { Box, Typography, Stack, Chip } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { accentColorForType } from 'common/src/other/PartnerUtils';

export default function PartnerCard({ partner, onClick, fromPriceLabel }) {
  const accent = accentColorForType(partner.partnerType);
  const cover = partner.images?.cover;
  const rating = partner.rating?.avg;
  const ratingCount = partner.rating?.count;

  return (
    <Box
      onClick={onClick}
      sx={{
        cursor: onClick ? 'pointer' : 'default',
        borderRadius: 4,
        overflow: 'hidden',
        transition: 'transform 0.18s ease, box-shadow 0.18s ease',
        '&:hover': onClick ? { transform: 'translateY(-2px)', boxShadow: '0 12px 30px rgba(0,0,0,0.08)' } : {},
      }}
    >
      <Box sx={{
        position: 'relative',
        width: '100%',
        aspectRatio: '4 / 3',
        backgroundColor: '#F3F4F6',
        backgroundImage: cover ? `url(${cover})` : 'none',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        borderRadius: 4,
      }}>
        <Chip
          size="small"
          label={partner.partnerType}
          sx={{
            position: 'absolute', top: 12, left: 12,
            backgroundColor: '#FFFFFFE6',
            color: accent,
            fontWeight: 700,
            fontSize: 11,
            letterSpacing: 0.4,
          }}
        />
        {rating ? (
          <Chip
            size="small"
            icon={<StarIcon sx={{ color: '#111 !important', fontSize: 14 }} />}
            label={`${rating.toFixed(1)}${ratingCount ? ` (${ratingCount})` : ''}`}
            sx={{
              position: 'absolute', top: 12, right: 12,
              backgroundColor: '#FFFFFFE6',
              color: '#111',
              fontWeight: 600,
            }}
          />
        ) : null}
      </Box>
      <Box sx={{ pt: 1.25, px: 0.5 }}>
        <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
          <Typography sx={{ fontWeight: 600, fontSize: 15, lineHeight: 1.25 }} noWrap>
            {partner.businessName}
          </Typography>
        </Stack>
        <Stack direction="row" spacing={0.5} alignItems="center" sx={{ mt: 0.25, color: '#6B7280' }}>
          <LocationOnIcon sx={{ fontSize: 14 }} />
          <Typography variant="caption" noWrap>
            {partner.address?.city || partner.address?.country || ''}
          </Typography>
        </Stack>
        {fromPriceLabel ? (
          <Typography sx={{ mt: 0.5, fontSize: 13 }}>
            <span style={{ fontWeight: 700 }}>{fromPriceLabel}</span>
          </Typography>
        ) : null}
      </Box>
    </Box>
  );
}
